const hotelConfig = {
  ROOM_TYPE_NAME_LIMIT: '50',
  HOTEL_NAME_LIMIT: '35',
};

export default hotelConfig;
